import { PublicClientApplication, InteractionRequiredAuthError, IPublicClientApplication } from '@azure/msal-browser';
import { loginRequest, msalConfig } from "./authConfig"

console.log("new PublicClientApplication");
const pca = new PublicClientApplication(msalConfig);
export function refreshToken(): Promise<string> {
  return new Promise((resolve, reject) => {
    pca
      .acquireTokenSilent({
        ...loginRequest
      })
      .then((response: { idToken: any; accessToken: any; }) => {
        console.log("entra en el refreshtoken");
        const idToken = response.idToken;
        const accessToken = response.accessToken;
        sessionStorage.setItem('idToken', idToken);
        sessionStorage.setItem('accessToken', accessToken);
        resolve(accessToken);
      })
      .catch((error: any) => {
        console.log('Error al adquirir silent token:', error);
      });
  });
}